/**
 * audio:busy 下行消息 → 用户可见文案（PRD §5.8.1）
 */

export interface AudioBusyPayload {
  reason: string
  activeSpeaker?: {
    clientId?: string
    name?: string
  }
}

/** 将 Gateway audio:busy 载荷格式化为 toast / banner 文案 */
export function formatAudioBusyMessage(data: AudioBusyPayload): string {
  switch (data.reason) {
    case 'floor_occupied': {
      const name = data.activeSpeaker?.name?.trim()
      return name ? `${name} 正在发言，请稍后再试` : '他人正在发言，请稍后再试'
    }
    case 'not_authorized':
      return '您暂无发言权限'
    case 'max_meetings':
      return '并行会议已达上限，请稍后再试'
    default:
      return '当前无法发言，请稍后再试'
  }
}
